import { styled, Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const OrdersFiltersMenuContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  minWidth: 350,
  maxWidth: 350,
}));

export const OrdersFiltersMenuInputs = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  // maxHeight: 412,
  // overflowY: 'auto',
}));

export const OrdersFiltersMenuActions = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const OrdersFiltersMenuIconButton = styled(Button)(({ theme }) => ({
  minWidth: 0,
  padding: theme.spacing(0, 1.5),
}));

export const OrdersFiltersMenuIconButtonIcon = styled(FontAwesomeIcon)(
  ({ theme }) => ({
    fontSize: theme.typography.pxToRem(17),
  }),
);
